import React from "react";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import { PropTypes } from "prop-types";
import { DeepBI, GA, WebEngage, RazorPay, GTM_RETARGETTING } from "../../../integrations";
import PayByRazorPay from "../razor-pay";
import { fetchRazarPay, fetchSelectOrder } from "../../../api";
import Cookies from "universal-cookie";
import { get } from "lodash";
import assetify from "@quintype/framework/assetify";
import spinner from "../../../../assets/images/spinner.svg";
import Iframe from "react-iframe";
import SkeletonLoading from "../skeleton-screen-loading";
const cookies = new Cookies();
let vuid = cookies.get("vuid");

class UtStdLast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readmore: true,
      modalIsOpen: null,
      popup: false,
      orderData: null,
      faq: false,
      loader: false,
      closePaywall: true,
      PaywallPlans: "",
      planId: "",
      type: "",
      ShowsuccessPopup: false,
      showLoader: false,
      showInputPopup: false,
      userInfo: "",
      Errormsg: "",
      validateInput: false,
      countryCode: "91",
      showCountrycode: false,
      ready: true,
      MAGAZINE_TYPE: "false",
      singleIssue: false
    };
  }

  handlePlansChange = (val, subId, SubType) => {
    if (this.state.loader) {
      return;
    }
    this.setState({
      PaywallPlans: val,
      planId: subId,
      type: SubType,
      showInputPopup: false,
      Errormsg: false,
      validateInput: false
    });
    if (SubType === "recurring_subscription" && !vuid) {
      this.setState({
        showInputPopup: true
      });
    } else {
      this.setState({
        showInputPopup: false
      });
    }
  };

  handleEvent = (val, subId, SubType) => {
    if (this.state.loader) {
      return;
    }
    this.setState({
      PaywallPlans: val,
      planId: subId,
      type: SubType,
      showInputPopup: false,
      Errormsg: false,
      validateInput: false
    });
    if (SubType === "recurring_subscription" && !vuid) {
      this.setState({
        showInputPopup: true
      });
    } else {
      this.setState({
        showInputPopup: false
      });
    }
  };

  handleClickEvent = args => {
    const { storyUrl, story } = this.props;
    GA.customEvent("Paywall Click", args, storyUrl);
    let paywallobj = {
      PaywallType: args,
      ArticleTitle: story.headline,
      ArticleID: story.id
    };

    WebEngage.pwEvent("std_paywall_clicked", paywallobj);
  };

  handleOpenRazarPay = args => {
    this.openModal();
    const { storyUrl, story } = this.props;
    GA.customEvent("Paywall Click", args, storyUrl);
    let paywallobj = {
      PaywallType: args,
      ArticleTitle: story.headline,
      ArticleID: story.id
    };

    WebEngage.pwEvent("std_paywall_clicked", paywallobj);
    DeepBI.pingPaywallClicked(story);
  };
  handleClickClose = args => {
    const { storyUrl } = this.props;
    GA.customEvent("Paywall Click", "paywall-popupclose", storyUrl);
    this.setState({ closePaywall: !this.state.closePaywall });
  };

  ShowSuccessPopup = () => {
    this.setState({ ShowsuccessPopup: true, showLoader: false });
    setTimeout(() => {
      this.setState({
        ShowsuccessPopup: false
      });
      window.location.href = this.props.storyUrl;
    }, 7000);
  };

  showLoader = () => {
    this.setState({ showLoader: true });
  };

  iframeLoader = () => {
    this.setState({ ready: false });
  };
  handleOnChange = event => {
    let data = event.target.value;
    let ValidCode = new RegExp(/[^\d\s]/).test(data);

    if (ValidCode === true) {
      this.setState({
        showCountrycode: false
      });
    } else {
      this.setState({
        showCountrycode: true
      });
    }

    this.setState({ userInfo: event.target.value });
  };
  handleOnChangeCountryCode = event => {
    let data = event.target.value;
    if (!isNaN(data)) {
      this.setState({ countryCode: data });
    }
  };
  openModal = (params, args = {}) => {
    let search = window && window.location && window.location.search;
    let Utm = new URLSearchParams(search);
    let utmsource = Utm.get("utm_source") ? Utm.get("utm_source") : "direct_web";
    let utmmedium = Utm.get("utm_medium") ? Utm.get("utm_medium") : "web";

    const storyId = get(this.props, ["story", "id"]);
    const payload = {};
    payload.order_type = this.state.type;
    payload.user_id = vuid || "";
    payload.order_items = this.state.planId;
    payload.mode = "live";
    payload.utm_source = utmsource;
    payload.utm_medium = utmmedium;
    payload.platform = "web";
    payload.utm_campaign = "Paywall";
    payload.aid = storyId;
    payload.thinmint = cookies.get("vikatanthinmint");

    if (this.state.type === "recurring_subscription") {
      if (!vuid) {
        if (this.state.userInfo === "") {
          this.setState({
            validateInput: true
          });
          return false;
        }
        let ValidCode = new RegExp(/[^\d\s]/).test(this.state.userInfo);
        if (ValidCode === true) {
          if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.userInfo) === false) {
            this.setState({
              validateInput: true
            });
            return false;
          }
        } else {
          if (
            (this.state.countryCode !== "" &&
              this.state.countryCode.includes("91") &&
              this.state.userInfo.length < 10) ||
            this.state.userInfo.length > 10
          ) {
            this.setState({
              validateInput: true
            });
            return false;
          }
        }
        Object.assign(payload, {
          user_info: ValidCode === true ? this.state.userInfo : `${this.state.countryCode}${this.state.userInfo}`
        });
      }
    }

    this.setState({ popup: true, loader: true });
    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
    fetchRazarPay(Object.assign(payload)).then(result => {
      this.setState({ loader: false });
      if (result.status === 1) {
        this.setState({ orderData: result, popup: false, modalIsOpen: rand });
        DeepBI.pingPaywallSubscribeNow(result);
        WebEngage.WebengagePaywallSubscribeNow(result);
      }
      if (result.status === 2) {
        this.setState({ Errormsg: result.msg, showInputPopup: !this.state.showInputPopup, validateInput: false });
        // window.location.href = global.location.href;
      }
    });
  };
  componentDidMount() {
    const { story, issueCollection, PlansList, user } = this.props;
    let MAGAZINE_TYPE = get(story, ["metadata", "story-attributes", "special-edition", 0], "false");
    this.setState({
      MAGAZINE_TYPE: MAGAZINE_TYPE
    });

    if (MAGAZINE_TYPE === "true") {
      const storyId = get(this.props, ["story", "id"]);
      const payload = {};
      payload.aid = storyId;
      fetchSelectOrder(Object.assign(payload)).then(data => {
        const subId = get(data, ["id"]);
        const actualPriceINR = get(data, ["iss_price"]);
        const SubType = "Single_Issue_Product";
        const wrapperImage = get(data, ["wrapper_url"]);
        const IssueTitle = get(data, ["issue_name"]);
        this.setState({
          PaywallPlans: actualPriceINR,
          planId: subId,
          type: SubType,
          orderData: data,
          wrapperImage: wrapperImage,
          IssueTitle: IssueTitle
        });
      });
    }
    GTM_RETARGETTING.reTargettingUser();
    PlansList &&
      PlansList.map((data, idx) => {
        const subId = get(data, ["sub_id"]);
        const actualPriceINR = get(data, ["actual_price_INR"]);
        const bestSeller = get(data, ["bestseller"]);
        const SubType = get(data, ["sub_type"]);

        if (bestSeller && bestSeller === true && MAGAZINE_TYPE === "false") {
          this.setState({ PaywallPlans: actualPriceINR, planId: subId, type: SubType });
        }
      });

    if (user) {
      DeepBI.paywallStory(story, issueCollection, "premium", "", "std");
      DeepBI.pingPaywallEventTrigger(story);
    }
  }

  componentWillMount() {
    RazorPay.loadScript();
  }
  closeModal = () => {
    this.setState({ popup: false, modalIsOpen: null });
    clearInterval(this.interval);
  };

  render() {
    const { storyUrl, story, PlansList, razaorpayKey, user } = this.props;
    const { PaywallPlans, planId, MAGAZINE_TYPE, wrapperImage, IssueTitle } = this.state;

    const PlansSection =
      PlansList &&
      PlansList.map((data, idx) => {
        const displayNname = get(data, ["display_name"]);
        const subId = get(data, ["sub_id"]);
        const actualPriceINR = get(data, ["actual_price_INR"]);
        const description = get(data, ["monthly_price"]);
        const bestSeller = get(data, ["bestseller"]);
        const SubType = get(data, ["sub_type"]);
        return (
          <li className={` ${planId === subId ? styles["benefits-active"] : styles["in-active"]}`} key={idx}>
            <div>
              <div className={styles["plans-tag"]}>
                {planId === subId ? (
                  <span className={styles["active"]}>
                    <Icon type="tick" className={styles["tick"]} />
                  </span>
                ) : null}
              </div>
              <div className={styles["pp-wrapper"]} onClick={() => this.handleEvent(actualPriceINR, subId, SubType)}>
                <div className={styles["pp-wrapper-grid"]}>
                  <div className={styles["custom-radio"]}>
                    <input
                      type="radio"
                      name="unique-plans"
                      checked={planId === subId}
                      value={actualPriceINR}
                      id={subId}
                      onChange={() => this.handlePlansChange(actualPriceINR, subId, SubType)}
                    />
                  </div>
                  <div className={styles["plans-tag"]}>{displayNname}</div>
                  <div className={styles["price-point"]}>
                    <Icon type="rupee" className={`${styles["rupee-icon"]} ${styles["paywall-rupee"]}`} />
                    <span className={styles["price"]}>{actualPriceINR}</span>
                  </div>
                </div>
                <p className={styles["plan-desc"]}>
                  {SubType === "Online_Subscription" ? (
                    <Icon type="rupee" className={`${styles["rupee-icon"]} ${styles["paywall-rupee"]}`} />
                  ) : (
                    ""
                  )}
                  {description}
                  {SubType === "Online_Subscription" ? <span className={styles["month"]}>/ month</span> : ""}
                </p>
                {bestSeller === true ? <div className={styles["recommended"]}>Best Value</div> : null}
              </div>
            </div>
          </li>
        );
      });

    return (
      <div className={styles["paywall-main-wrapper"]}>
        {MAGAZINE_TYPE === "true" && wrapperImage ? (
          <div className={styles["paywall-select-wrapper"]}>
            {" "}
            <div
              className={`${styles["paywall-option"]} ${styles["paywall-select-option"]}
              `}
            >
              <div className={styles["premium-header"]}>
                <div className={styles["premium-header-grid"]}>
                  <img
                    src={
                      IssueTitle && IssueTitle === "விகடன் செலக்ட் ஸ்டோரி"
                        ? "https://gumlet.assettype.com/vikatan/2022-09/c05bf8e3-5bff-4c80-ab75-a7d7c3e01b98/vikatan_select_icon.png"
                        : "https://gumlet.assettype.com/vikatan/2022-09/a9813ae9-cf43-44a8-9c71-c5f87896da30/paywall_diwali_malar_icon.png"
                    }
                    alt=""
                    className={styles["select-icon"]}
                  />
                  <h3 className={styles["premium-header-txt"]}>{IssueTitle && IssueTitle}</h3>
                </div>
              </div>
              <div className={styles["paywall-select-content"]}>
                <img
                  className={styles["select-img"]}
                  src={`${wrapperImage && wrapperImage}?auto=format%2Ccompress&format=webp&w=128&dpr=1.0`}
                />

                <div>
                  <h6 className={styles["paywall-select-main-txt"]}>
                    <strong className={styles["header-strong"]}>அன்பு வாசகர்களே... </strong>
                    <span className={styles["header-span"]}>
                      இந்த சிறப்பிதழின் கட்டுரைகளைப் படித்து மகிழ்ந்திட, கீழே கட்டணம் செலுத்திடுங்கள். உங்கள் வழக்கமான
                      சந்தா / Free Trial ஆகியவை இதற்குப் பொருந்தாது!
                    </span>
                  </h6>
                  <div className={styles["series-wrapper"]}>
                    {this.state.loader ? (
                      <div className={styles["dots-wrapper"]}>
                        <div className={styles["dot-loader"]} />
                        <div className={`${styles["dot-loader"]} ${styles["dot-loader-two"]}`} />
                        <div className={`${styles["dot-loader"]} ${styles["dot-loader-three"]}`} />
                      </div>
                    ) : (
                      <a className={styles["btn-auto"]} onClick={() => this.handleOpenRazarPay("paywall-subscribe")}>
                        Buy now{" "}
                        <span className={styles["select-btn-auto"]}>
                          <Icon type="rupee" className={`${styles["rupee-icon"]} ${styles["series-rupee-icon"]}`} />
                          {PaywallPlans && PaywallPlans}
                        </span>
                      </a>
                    )}

                    {this.state.modalIsOpen ? (
                      <PayByRazorPay
                        vuid={vuid}
                        closeModal={this.closeModal}
                        storyUrl={storyUrl}
                        orderData={this.state.orderData}
                        amount={PaywallPlans}
                        story={story}
                        orderType={this.state.type}
                        ShowSuccess={this.ShowSuccessPopup}
                        showLoader={this.showLoader}
                        razaorpayKey={razaorpayKey}
                        userInfo={this.state.userInfo}
                        countryCode={this.state.countryCode}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : MAGAZINE_TYPE === "true" ? (
          <div className={`${styles["card"]}`}>
            <div className={`${styles["card__image"]} ${styles["loading"]}`} />
            <div>
              <div className={`${styles["card__title"]} ${styles["loading"]}`} />
              <div className={`${styles["card__description"]} ${styles["loading"]}`} />
              <div
                className={`${styles["card__description"]} ${styles["loading"]} ${
                  styles["card__description__only-mbl"]
                }`}
              />
              <div
                className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${
                  styles["loading"]
                }`}
              />
              <div
                className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${
                  styles["loading"]
                }`}
              />
            </div>
          </div>
        ) : null}
        {user && MAGAZINE_TYPE !== "true" ? (
          <div>
            <div className={styles["paywall-option-popup"]}>
              {this.state.closePaywall ? (
                <div className={styles["paywall-popup"]}>
                  <div className={styles["close-div"]} onClick={() => this.handleClickClose()}>
                    <Icon type={"close"} />
                  </div>
                  <div className={styles["premium-header"]}>
                    <Icon type="premium" className={styles["premium-icon"]} />

                    <h3 className={styles["premium-header-txt"]}>இது ஒரு பிரீமியம் ஸ்டோரி</h3>
                  </div>
                  <h6 className={styles["header-content"]}>
                    <strong className={styles["header-strong"]}>அன்பு வாசகர்களே... </strong>
                    <span className={styles["header-span"]}>
                      இந்த சவாலான காலகட்டத்தில், விகடன் சந்தாதாரராக உங்கள் ஆதரவு எங்களுக்கு மிக முக்கியம். எனவே சந்தா
                      செலுத்தி இதுபோன்ற அனைத்து பிரீமியம் கட்டுரைகளையும் படித்து மகிழ்ந்திடுங்கள்!
                    </span>
                  </h6>
                  <div className={styles["paywall-popup-cnt"]}>
                    <ul className={styles["plans"]}>{PlansSection}</ul>
                    {this.state.Errormsg !== "" ? (
                      <div className={styles["plan-content"]}>{this.state.Errormsg}</div>
                    ) : null}
                    {this.state.showInputPopup === true ? (
                      <div>
                        <div className={styles["input-grid"]}>
                          {this.state.showCountrycode === true ? (
                            <div className={styles["input-plus"]}>
                              <input
                                placeholder="91"
                                className={styles["country-code"]}
                                onChange={this.handleOnChangeCountryCode}
                                value={this.state.countryCode}
                                maxLength={4}
                                type="text"
                              />
                            </div>
                          ) : null}
                          <input
                            placeholder="Email/Phone number"
                            className={styles["input-filed"]}
                            onChange={this.handleOnChange}
                            value={this.state.userInfo}
                            type="text"
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.validateInput ? (
                      <div className={styles["error-msg"]}>* Please Enter Valid Email/Phone Number</div>
                    ) : (
                      ""
                    )}
                  </div>

                  {this.state.loader ? (
                    <div className={styles["dots-wrapper"]}>
                      <div className={styles["dot-loader"]} />
                      <div className={`${styles["dot-loader"]} ${styles["dot-loader-two"]}`} />
                      <div className={`${styles["dot-loader"]} ${styles["dot-loader-three"]}`} />
                    </div>
                  ) : (
                    <a className={styles["btn-auto"]} onClick={() => this.handleOpenRazarPay("paywall-subscribe-mob")}>
                      Subscribe now
                    </a>
                  )}

                  {this.state.modalIsOpen ? (
                    <PayByRazorPay
                      vuid={vuid}
                      closeModal={this.closeModal}
                      storyUrl={storyUrl}
                      orderData={this.state.orderData}
                      amount={PaywallPlans}
                      story={story}
                      orderType={this.state.type}
                      ShowSuccess={this.ShowSuccessPopup}
                      showLoader={this.showLoader}
                      razaorpayKey={razaorpayKey}
                      userInfo={this.state.userInfo}
                      countryCode={this.state.countryCode}
                    />
                  ) : null}
                </div>
              ) : null}
              <div
                className={`${styles["paywall-option"]} ${
                  !this.state.closePaywall ? styles["active"] : styles["mobile-in-active"]
                }`}
              >
                <div className={styles["premium-header"]}>
                  <Icon type="premium" className={styles["premium-icon"]} />

                  <h3 className={styles["premium-header-txt"]}>இது ஒரு பிரீமியம் ஸ்டோரி</h3>
                </div>
                <h6 className={styles["header-content"]}>
                  <strong className={styles["header-strong"]}>அன்பு வாசகர்களே... </strong>
                  <span className={styles["header-span"]}>
                    இந்த சவாலான காலகட்டத்தில், விகடன் சந்தாதாரராக உங்கள் ஆதரவு எங்களுக்கு மிக முக்கியம். எனவே சந்தா
                    செலுத்தி இதுபோன்ற அனைத்து பிரீமியம் கட்டுரைகளையும் படித்து மகிழ்ந்திடுங்கள்!
                  </span>
                </h6>
                <div className={styles["plans-wrapper"]}>
                  <img src="https://gumlet.assettype.com/vikatan/2022-05/7390d048-f12f-4855-ac98-c595ed2130f9/paywall_magazine_image.png" />
                  <div>
                    <ul className={styles["plans"]}>{PlansSection}</ul>
                    {this.state.Errormsg !== "" ? (
                      <div className={styles["plan-content"]}>{this.state.Errormsg}</div>
                    ) : null}
                    {this.state.showInputPopup === true ? (
                      <div>
                        <div className={styles["input-grid"]}>
                          {this.state.showCountrycode ? (
                            <div className={styles["input-plus"]}>
                              <input
                                placeholder="91"
                                className={styles["country-code"]}
                                onChange={this.handleOnChangeCountryCode}
                                value={this.state.countryCode}
                                maxLength={4}
                                type="text"
                              />
                            </div>
                          ) : null}
                          <input
                            placeholder="Email/Phone number"
                            className={styles["input-filed"]}
                            onChange={this.handleOnChange}
                            value={this.state.userInfo}
                            type="text"
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.validateInput ? (
                      <div className={styles["error-msg"]}>* Please Enter Valid Email/Phone Number</div>
                    ) : (
                      ""
                    )}

                    {this.state.loader ? (
                      <div className={styles["dots-wrapper"]}>
                        <div className={styles["dot-loader"]} />
                        <div className={`${styles["dot-loader"]} ${styles["dot-loader-two"]}`} />
                        <div className={`${styles["dot-loader"]} ${styles["dot-loader-three"]}`} />
                      </div>
                    ) : (
                      <a className={styles["btn-auto"]} onClick={() => this.handleOpenRazarPay("paywall-subscribe")}>
                        Subscribe now
                      </a>
                    )}

                    {this.state.modalIsOpen ? (
                      <PayByRazorPay
                        vuid={vuid}
                        closeModal={this.closeModal}
                        storyUrl={storyUrl}
                        orderData={this.state.orderData}
                        amount={PaywallPlans}
                        story={story}
                        orderType={this.state.type}
                        ShowSuccess={this.ShowSuccessPopup}
                        showLoader={this.showLoader}
                        razaorpayKey={razaorpayKey}
                        userInfo={this.state.userInfo}
                        countryCode={this.state.countryCode}
                      />
                    ) : null}
                    {!this.state.Isuser && (
                      <div>
                        <p className={styles["premium-para"]}>
                          Have an account already?{" "}
                          <a
                            href={`https://login.vikatan.com?&utm_source=Paywall&utm_medium=article&utm_campaign=paywall_experiment&redirect_url=${encodeURIComponent(
                              storyUrl
                            )}`}
                            className={styles["btn-link"]}
                            onClick={() => this.handleClickEvent("paywall-login")}
                          >
                            Log in
                          </a>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          MAGAZINE_TYPE !== "true" && (
            <div className={styles["premium-story"]}>
              <div className={`${styles["iframe-outer"]} ${this.state.ready ? styles["ac"] : styles["ec"]}`}>
                <div className={styles["skeloton"]}>
                  <SkeletonLoading />
                </div>
                <Iframe
                  frameBorder="0"
                  onLoad={this.iframeLoader}
                  className={`${styles["iframe-outer"]}`}
                  src={`https://login.vikatan.com/premium-datawall?&path=${encodeURIComponent(
                    global && global.location && global.location.href
                  )}`}
                  loading="lazy"
                />
              </div>
            </div>
          )
        )}
        {this.state.showLoader ? (
          <div className={styles["payment-loader"]}>
            <img src={assetify(spinner)} className={styles["loader-image"]} />
          </div>
        ) : null}
        {this.state.ShowsuccessPopup ? (
          <div className={styles["success-popup-wrapper"]}>
            <div className={styles["app-content"]}>
              <div className={styles["success-txt-wrapper"]}>
                <Icon type="tick" className={styles["success-icon"]} />
                <div className={styles["success-txt"]}>Payment Successful</div>
              </div>
              <p className={styles["success-para"]}>
                உங்கள் சந்தா கட்டணம் வெற்றிகரமாக செலுத்தப்பட்டுவிட்டது. Login, Billing விவரங்கள் உங்கள் மின்னஞ்சலுக்கு
                அனுப்பப்பட்டுள்ளன. சந்தாதாரராக விகடன் குடும்பத்தில் இணைந்தமைக்கு நன்றி!
              </p>
              <h6 className={styles["redirect-msg"]}>* Don&apos;t refresh You will be redirected in 5 seconds</h6>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

UtStdLast.propTypes = {
  type: PropTypes.string,
  storyId: PropTypes.string,
  storyUrl: PropTypes.string,
  closeThis: PropTypes.func,
  user: PropTypes.bool,
  story: PropTypes.shape(),
  issueCollection: PropTypes.shape(),
  PlansList: PropTypes.shape(),
  razaorpayKey: PropTypes.shape()
};

export default UtStdLast;
